export const QueryKey = {
  GET_ALL_BOOKINGS_BY_QUERY: 'GET_ALL_BOOKINGS_BY_QUERY',
  GET_ALL_SERVICE_BY_QUERY: 'GET_ALL_SERVICE_BY_QUERY',
  GET_SERVICE_BY_QUERY: 'GET_SERVICE_BY_QUERY',
  GET_ALL_PUBLIC_SERVICE_BY_PROVIDER: 'GET_ALL_PUBLIC_SERVICE_BY_PROVIDER',

  // Phase 2 — Quote-based booking (Job vertical)
  MY_JOBS: 'MY_JOBS',
  JOB_DETAIL: 'JOB_DETAIL',
  JOB_THREAD: 'JOB_THREAD',
  JOB_REVISIONS: 'JOB_REVISIONS',

  // Phase 3 — Package-based booking (CustomerPackage vertical)
  MY_CUSTOMER_PACKAGES: 'MY_CUSTOMER_PACKAGES',
  CUSTOMER_PACKAGE_DETAIL: 'CUSTOMER_PACKAGE_DETAIL',
};
